import { useMutation, useQueryClient } from 'react-query';
import { useActionLogger } from '@/shared/hooks/action-logger';
import { deleteUser } from '../index';
export const useDeleteUser = (callback) => {
    const queryClient = useQueryClient();
    const { setAction } = useActionLogger();
    return useMutation(deleteUser, {
        onSuccess: () => {
            queryClient.invalidateQueries('GetUsers');
            setAction({
                type: 'success',
                message: 'Removing the user was successful',
            });
            if (callback && typeof callback === 'function') {
                callback();
            }
        },
        onError: (error) => {
            setAction({
                type: 'error',
                message: error.toString(),
            });
        },
    });
};
